<script setup lang="ts">
import type { IBrandConfig } from '@/config/'

interface TProps {
  brandConfig: IBrandConfig
  className: string
}

defineProps<TProps>()
</script>
<template>
  <div
    data-testid="main-logo"
    :class="`text-primary ${className}`"
    role="image"
    :aria-label="brandConfig.productName"
    aria-roledescription="Image"
  >
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 84 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xml:space="preserve"
      xmlns:serif="http://www.serif.com/"
      style="fill-rule: evenodd; clip-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 2"
    >
      <g transform="matrix(1.03758,0,0,1.11117,-30.6347,7.46921)">
        <g transform="matrix(1.09927,0,0,1.02209,-8.11685,-0.526032)">
          <g transform="matrix(1.13378,0,0,1.13378,-1.94539,1.97941)" fill="currentColor" opacity="0.7">
            <path
              d="M72.834,-3.074L74.95,-3.074L74.95,10.842L78.409,10.842L78.409,12.632L72.834,12.632L72.834,-3.074Z"
              fillRule="nonzero"
            />
            <path
              d="M85.631,2.104L85.631,12.632L83.688,12.632L83.688,11.279C83.41,11.856 83.132,12.253 82.854,12.47C82.576,12.687 82.21,12.795 81.756,12.795C80.881,12.795 80.24,12.347 79.833,11.452C79.426,10.557 79.223,9.153 79.223,7.241C79.223,5.417 79.426,4.076 79.833,3.218C80.24,2.36 80.881,1.931 81.756,1.931C82.556,1.931 83.2,2.385 83.688,3.294L83.688,2.104L85.631,2.104ZM81.237,7.322C81.237,8.706 81.328,9.672 81.512,10.221C81.701,10.771 82.034,11.045 82.508,11.045C82.942,11.045 83.258,10.761 83.454,10.191C83.651,9.581 83.749,8.641 83.749,7.373C83.749,6.098 83.651,5.156 83.454,4.545C83.258,3.975 82.942,3.691 82.508,3.691C82.047,3.691 81.718,3.962 81.522,4.504C81.332,5.006 81.237,5.946 81.237,7.322Z"
            />
            <path
              d="M87.839,-4.651L89.782,-4.651L89.782,3.294C89.917,3.036 90.056,2.819 90.199,2.643C90.341,2.467 90.48,2.331 90.616,2.236C90.887,2.033 91.24,1.931 91.674,1.931C92.121,1.931 92.508,2.034 92.834,2.241C93.159,2.448 93.425,2.768 93.632,3.202C93.839,3.636 93.993,4.189 94.095,4.861C94.197,5.532 94.248,6.329 94.248,7.251C94.248,9.163 94.044,10.566 93.637,11.457C93.23,12.349 92.593,12.795 91.725,12.795C91.264,12.795 90.894,12.687 90.616,12.47C90.338,12.253 90.06,11.856 89.782,11.279L89.782,12.632L87.839,12.632L87.839,-4.651ZM92.233,7.424C92.233,5.993 92.138,5.023 91.949,4.515C91.765,3.965 91.437,3.691 90.962,3.691C90.514,3.691 90.199,3.969 90.016,4.525C89.833,5.074 89.741,6.024 89.741,7.373C89.741,8.716 89.833,9.665 90.016,10.221C90.199,10.771 90.514,11.045 90.962,11.045C91.423,11.045 91.752,10.774 91.949,10.232C92.138,9.73 92.233,8.794 92.233,7.424Z"
            />
          </g>
          <g transform="matrix(1.13378,0,0,1.13378,-1.94539,1.97941)" fill="currentColor">
            <path
              d="M35.674,-3.074L42.561,-3.074L42.561,-1.223L40.191,-1.223L40.191,12.632L38.116,12.632L38.116,-1.223L35.674,-1.223L35.674,-3.074Z"
            />
            <path
              d="M47.088,9.082L48.898,9.082C48.756,11.557 47.739,12.795 45.847,12.795C45.284,12.795 44.801,12.69 44.397,12.48C43.994,12.269 43.66,11.944 43.395,11.503C43.131,11.062 42.936,10.503 42.81,9.825C42.685,9.147 42.622,8.34 42.622,7.404C42.622,5.545 42.881,4.169 43.4,3.274C43.919,2.378 44.721,1.931 45.806,1.931C47.915,1.931 48.97,3.789 48.97,7.505L48.97,7.75L44.524,7.75C44.524,10.001 44.972,11.127 45.867,11.127C46.681,11.127 47.088,10.445 47.088,9.082ZM46.986,6.346C46.905,5.24 46.779,4.515 46.61,4.169C46.433,3.782 46.148,3.589 45.755,3.589C45.355,3.589 45.07,3.782 44.901,4.169C44.731,4.515 44.606,5.24 44.524,6.346L46.986,6.346Z"
            />
            <path
              d="M50.699,2.104L52.642,2.104L52.642,3.314C53.198,2.392 53.917,1.931 54.798,1.931C55.653,1.931 56.263,2.267 56.63,2.938C56.833,3.318 56.935,4.053 56.935,5.145L56.935,12.632L54.992,12.632L54.982,5.593C54.982,4.881 54.897,4.376 54.727,4.077C54.558,3.779 54.266,3.63 53.852,3.63C53.629,3.63 53.44,3.669 53.288,3.747C53.135,3.825 53.012,3.95 52.917,4.123C52.822,4.296 52.752,4.521 52.708,4.799C52.664,5.078 52.642,5.42 52.642,5.827L52.642,12.632L50.699,12.632L50.699,2.104Z"
            />
            <path
              d="M65.347,7.455C65.347,11.015 64.245,12.795 62.041,12.795C59.837,12.795 58.735,10.988 58.735,7.373C58.735,3.745 59.834,1.931 62.031,1.931C62.601,1.931 63.094,2.039 63.511,2.256C63.928,2.473 64.272,2.809 64.544,3.263C64.815,3.718 65.017,4.291 65.149,4.983C65.281,5.674 65.347,6.498 65.347,7.455ZM63.333,7.404C63.333,6.02 63.242,5.057 63.059,4.515C62.875,3.965 62.55,3.691 62.082,3.691C61.621,3.691 61.292,3.962 61.095,4.504C60.912,5.047 60.821,5.993 60.821,7.343C60.821,8.692 60.912,9.635 61.095,10.171C61.292,10.713 61.621,10.984 62.082,10.984C62.543,10.984 62.865,10.716 63.048,10.181C63.238,9.679 63.333,8.753 63.333,7.404Z"
            />
            <path
              d="M67.158,2.104L69.101,2.104L69.101,3.416C69.433,2.86 69.762,2.47 70.088,2.246C70.413,2.022 70.844,1.894 71.38,1.86L71.38,3.894C71.244,3.874 71.129,3.864 71.034,3.864C70.335,3.864 69.837,4.043 69.538,4.403C69.247,4.755 69.101,5.373 69.101,6.254L69.101,12.632L67.158,12.632L67.158,2.104Z"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
